import React from "react";
import { CalendarEvent } from "./CalendarDayCard";
import { PaziaBox } from "components/atoms";
import { CourseEvents } from "./CourseEvents";
import { monthNames } from "components/molecules/MonthCalendar";

type SelectedCalendarDayPanelProps = {
  date: {
    day: number;
    month: number;
    year: number;
  };
  events: CalendarEvent[];
};

export const SelectedCalendarDayPanel = ({
  selected: { date, events },
}: {
  selected: SelectedCalendarDayPanelProps;
}) => {
  const eventsGroupedByCourseAndOrderedByTime = events.reduce((acc, event) => {
    const courseEvents = acc.get(event.courseId) || [];
    courseEvents.push(event);
    acc.set(event.courseId, courseEvents);
    return acc;
  }, new Map<number, CalendarEvent[]>());

  return (
    <PaziaBox className="mt-[55px] w-28">
      <div>
        <div className="text-center text-lg font-semibold">
          {date.day} {monthNames[date.month]} {date.year}
        </div>

        {Array.from(eventsGroupedByCourseAndOrderedByTime).map(([courseId, courseEvents]) => (
          <CourseEvents key={courseId} courseName={courseEvents[0].courseName} events={courseEvents} />
        ))}
      </div>
    </PaziaBox>
  );
};
